/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from "react";
import {
  IconBox,
  IconChevronLeft,
  IconCloudDown,
  IconEdit,
} from "@tabler/icons-react";
import { useNavigate, useParams } from "react-router-dom";
import {
  useMerchantUpdateMutation,
  useFetchMerchantSingleData,
} from "../../apis/merchantApis";
import formatDate, { maskedSecretKey } from "../../utilities/helper";
import AddMerchantModal from "./_components/AddMerchantModal";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import NewCommonModal from "../../components/common/NewCommonModal";
import { useSalesAllIntegrationData } from "../../apis/integrationApis";
import { use3PLListData } from "../../apis/3plApis";
import { usePermission } from "../../hooks/usePermissionTabs";




  const TwoCol = ({
    label,
    value,
  }: {
    label: string;
    value: React.ReactNode;
  }) => (
    <div className="text-sm text-[#1E293B] flex justify-between items-center gap-1 border-b py-3 last:border-0 px-4 ">
      <p className=" text-[#212121] capitalize">{label}:</p>
      <p className="font-medium"> {value}</p>
    </div>
  );

  const PlatformCard = ({
    items,
    title,
    img,
    data = [],
  }: {
    data?: any[];
    items?: string[];
    title?: string;
    img?: string;
  }) => (
    <div className="bg-[#F7F6F2] rounded-3xl  p-4 space-y-4 flex flex-col justify-between">
      <h3 className="text-[#212121] font-medium text-base ">{title}</h3>
      {/* Data list */}
      {data?.length > 0 ? (
        <div className="space-y-4 h-full">
          {data?.map((elm, i) => (
            <div
              key={i}
              className="text-sm rounded-lg font-medium flex items-center gap-3"
            >
              {elm.companyLogo && (
                <img
                  src={elm.companyLogo}
                  className="w-8 h-8 rounded flex-shrink-0"
                  alt={elm.companyName}
                />
              )}
              <p className="line-clamp-1 ">{elm.companyName}</p>
            </div>
          ))}
        </div>
      ) : (
        // Fallback (Not connected yet)
        <div className="flex flex-col items-center justify-center space-y-2 h-full">
          <IconBox strokeWidth={1} size={28} />
          <div className="space-y-0 text-center">
            <h3 className="text-sm font-medium">Not Connected Yet</h3>
            <p className="text-xs text-gray-600">
              To connect go to Integration
            </p>
          </div>
          <button className="bg-yellow-500/20 border border-yellow-500 text-[#212121] rounded-full px-4 py-1.5 font-medium text-sm">
            Connect
          </button>
        </div>
      )}
    </div>
  );


type FormValues = {
  id?: string;
  name: string;
  mobileNo: string;
  email: string;
  clientId?: string;
  secretKey?: string;
  contactType: string;
  vatNumber: string;
  nationalId: string;
  nationalCopy: string;
  crNumber: string;
  warehouse: string;
  contactPerson: string;
  district: string;
  city: string;
  paymentTerm: string;
  access: string;
  clientType: string;
  location: string;
  status?: string;
  contractDate: Date;
  vatDocument: File | undefined;
  companyLogo: File | undefined;
  crCopy: File | undefined;
  contractDocument: File | undefined;
};
const Section = ({
  title,
  children,
}: {
  title?: string;
  children: React.ReactNode;
}) => (
  <div className="p-4 bg-[#F7F6F2] rounded-3xl border border-[#EFEFEF] ">
    {/* {title === "TimeLine" ? null : (
      <h2 className="text-[#212121] font-medium text-lg pb-3">{title}</h2>
    )} */}
    <div className="grid grid-cols-12 gap-x-6">{children}</div>
  </div>
);
export default function ViewMerchantDetails() {
  const params: any = useParams();
  const navigate = useNavigate();
  const { data: merchantData, refetch: fetchMerchantData } =
    useFetchMerchantSingleData(params?.id);

  const { data: salesChannels } = useSalesAllIntegrationData();
  const { data: shippingChannels } = use3PLListData();


  useEffect(() => {
    if (params?.id) {
      fetchMerchantData();
    }
  }, [params]);
  const { mutate, isPending } = useMerchantUpdateMutation(merchantData?.id);
  const [selectedDocument, setSelectedDocument] = useState<any>({
    crCopy: false,
    companyLogo: false,
    vatDocument: false,
    contractDocument: false,
    nationalCopy: false,
  });
  const [credential, setCredential] = useState<boolean>(false);
  const credentialToggleModal = () => {
    setCredential(!credential);
    if (!credential) {
      reset();
    }
  };
  const {
    register,
    handleSubmit,
    clearErrors,
    reset,
    setValue,
    control,
    watch,
    formState: { errors },
  } = useForm<FormValues>();
  const [allIds, setAllIds] = useState<any>();
  const getIds = (data: any) => {
    setAllIds(data);
  };

  const handleUpdate = (data: FormValues) => {
    let {
      clientId,
      secretKey,
      crCopy,
      companyLogo,
      contractDocument,
      vatDocument,
      nationalCopy,
      ...otherData
    } = data;

    mutate(
      {
        ...otherData,
        ...(selectedDocument?.crCopy && { crCopy: crCopy }),
        ...(selectedDocument?.vatDocument && { vatDocument: vatDocument }),
        ...(watch("vatDocument") && { vatDocumentAvailabel: true }),
        ...(watch("nationalCopy") && { NationalIdAvailabel: true }),
        ...(watch("crCopy") && { crCopyAvailabel: true }),
        ...(watch("contractDocument") && { contractDocumentAvailabel: true }),
        ...(selectedDocument?.companyLogo && { companyLogo: companyLogo }),
        ...(selectedDocument?.nationalCopy && { nationalCopy: nationalCopy }),
        ...(selectedDocument?.contractDocument && {
          contractDocument: contractDocument,
        }),
        ...allIds,
      },
      {
        onSuccess: () => {
          setSelectedDocument({
            crCopy: false,
            companyLogo: false,
            vatDocument: false,
            contractDocument: false,
            nationalCopy: false,
          });
          fetchMerchantData();
          credentialToggleModal();
          toast.success("Merchant Update successfully!");
          navigate("/users?tab=Merchant");
        },
        onError: (error: any) => {
          const errorMessage =
            error?.response?.data?.error?.message ||
            error?.response?.data?.message ||
            error?.message ||
            (typeof error === 'string' ? error : null) ||
            "Failed to Update Merchant";

          toast.error(errorMessage);
        },
      }
    );
  };
  const { allowed: canUpdateClient, isLoading } = usePermission(
    "clients",
    "update"
  );
  return (
    <>
      <div className="p-4 pt-0 space-y-4">
        {/* Header */}
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-2">
            <button
              onClick={() => navigate(-1)}
              className="p-1.5 border border-[#D2D2D2] rounded-full hover:bg-[#F7F6F2] transition"
            >
              <IconChevronLeft strokeWidth={1.5} size={22} />
            </button>
            <div className="flex items-center gap-2">
              <img
                src={merchantData?.companyLogo || "/img/dummy-logo.png"}
                className="w-10 h-10 rounded-md border object-cover"
                alt=""
              />
              <h1 className="text-xl font-medium text-[#212121] tracking-[-0.5px]  ">
                {merchantData?.name}
              </h1>
            </div>
          </div>
        </div>

        {/* Sections */}
        <div className="space-y-4">
          {/* Shipment Info */}
          <div className="grid grid-cols-1 gap-4">
            <Section>
              <div className="flex justify-between items-center col-span-12 pb-3 mb-4 lg:mb-0">
                <h3 className="text-[#212121] font-medium text-lg ">
                  Merchant Details{" "}
                </h3>
                {canUpdateClient && (
                  <button
                    onClick={() => {
                      setCredential(true);
                    }}
                    className="flex items-center gap-1  p-2.5  text-sm rounded-full border border-[#FFFFFF] bg-[#F7F6F2]"
                  >
                    <IconEdit stroke={1.5} size={24} />
                  </button>
                )}
              </div>
              <div className="bg-[#FCFDF8] border rounded-2xl overflow-hidden col-span-12 lg:col-span-4 mb-4 lg:mb-0">
                <h3 className="text-[#212121] font-medium text-base capitalize border-b border-gray-300 border-dashed py-2 w-full bg-[#F7F6F2] rounded-t-xl px-4">
                  Personal Details
                </h3>
                <TwoCol label="Merchant Id" value={merchantData?.clientId} />
                <TwoCol label="Merchant Name" value={merchantData?.name} />
                <TwoCol
                  label="Secret Key"
                  value={maskedSecretKey(merchantData?.secretKey)}
                />
                <TwoCol label="Mobile Number" value={merchantData?.mobileNo} />
                <TwoCol label="Mail" value={merchantData?.email} />
                <TwoCol
                  label="Contact Person"
                  value={merchantData?.contactPerson ?? ""}
                />
                <TwoCol label="Warehouse" value={merchantData?.warehouseName} />
                <TwoCol label="Country" value={merchantData?.country} />
                <TwoCol label="City" value={merchantData?.city} />
                <TwoCol label="Access" value={merchantData?.access} />
                <TwoCol
                  label="Payment Terms"
                  value={
                    merchantData?.paymentTerm?.[0]?.toUpperCase() +
                    merchantData?.paymentTerm?.slice(1)?.toLowerCase()
                  }
                />
                <TwoCol
                  label="Created Date"
                  value={formatDate(merchantData?.createdAt)}
                />
                <TwoCol label="Address" value={merchantData?.location} />
                {merchantData?.isNippco && (
                  <TwoCol
                    label="Coverage Radius"
                    value={`${merchantData?.radius} km`}
                  />
                )}
              </div>
              <div className="bg-[#FCFDF8] border rounded-2xl overflow-hidden col-span-12 lg:col-span-4 mb-4 lg:mb-0">
                <h3 className="text-[#212121] font-medium text-base capitalize border-b border-gray-300 border-dashed py-2 w-full bg-[#F7F6F2] rounded-t-xl px-4">
                  Documents Details
                </h3>
                <div className="grid grid-cols-1 ">
                  <TwoCol
                    label="Start Contract Date"
                    value={
                      <div className="flex items-center gap-1">
                        <p> {formatDate(merchantData?.contractDate)} </p>
                        {merchantData?.contractDocument && (
                          <a
                            onClick={() => {
                              const url = merchantData.contractDocument;
                              const link = document.createElement("a");
                              link.href = url;
                              link.target = "_blank";
                              link.download = "";
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);
                            }}
                            className="inline-flex items-center justify-cente hover:bg-[#FBD037]/20 p-0.5 px-1 rounded cursor-pointer"
                          >
                            <IconCloudDown strokeWidth={1.5} size={22} />
                          </a>
                        )}
                      </div>
                    }
                  />
                  <TwoCol
                    label="Tax/VAT Number"
                    value={
                      <div className="flex items-center gap-1">
                        <p> {merchantData?.vatNumber || ""} </p>
                        {merchantData?.vatDocument && (
                          <a
                            onClick={() => {
                              const url = merchantData.vatDocument;
                              const link = document.createElement("a");
                              link.href = url;
                              link.target = "_blank";
                              link.download = "";
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);
                            }}
                            className="inline-flex items-center justify-cente hover:bg-[#FBD037]/20 p-0.5 px-1 rounded"
                          >
                            <IconCloudDown strokeWidth={1.5} size={22} />
                          </a>
                        )}
                      </div>
                    }
                  />
                  <TwoCol
                    label="Cr Number"
                    value={
                      <div className="flex items-center gap-1">
                        <p>{merchantData?.crNumber || ""} </p>
                        {merchantData?.crCopy && (
                          <a
                            onClick={() => {
                              const url = merchantData.crCopy;
                              const link = document.createElement("a");
                              link.href = url;
                              link.target = "_blank";
                              link.download = "";
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);
                            }}
                            className="inline-flex items-center justify-cente hover:bg-[#FBD037]/20 p-0.5 px-1 rounded cursor-pointer"
                          >
                            <IconCloudDown strokeWidth={1.5} size={22} />
                          </a>
                        )}
                      </div>
                    }
                  />
                  <TwoCol
                    label="Merchant National ID"
                    value={
                      <div className="flex items-center gap-1">
                        <p>{merchantData?.nationalId || ""}</p>
                        {merchantData?.nationalCopy ? (
                          <a
                            onClick={() => {
                              const url = merchantData.nationalCopy;
                              const link = document.createElement("a");
                              link.href = url;
                              link.target = "_blank";
                              link.download = "";
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);
                            }}
                            className="inline-flex items-center justify-cente hover:bg-[#FBD037]/20 p-0.5 px-1 rounded cursor-pointer"
                          >
                            <IconCloudDown strokeWidth={1.5} size={22} />
                          </a>
                        ) : (
                          ""
                        )}
                      </div>
                    }
                  />
                </div>
              </div>

              <div className="bg-[#FCFDF8] border rounded-2xl overflow-hidden col-span-12 lg:col-span-4">
                <h3 className="text-[#212121] font-medium text-base capitalize border-b border-gray-300 border-dashed py-2 w-full bg-[#F7F6F2] rounded-t-xl px-4">
                  Access & Permissions
                </h3>

                <TwoCol label="Order Management" value="" />
                <TwoCol label="Staff Management" value="" />
                <TwoCol label="Integration" value="" />
                <TwoCol label="Order Management" value="" />
                <TwoCol label="Payment method" value="" />
                <TwoCol label="Pickup Management" value="" />
              </div>
            </Section>

            {/* Platform Cards */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 col-span-1">
              <PlatformCard title="Shiping Channels" data={salesChannels} />
              <PlatformCard title="3pl Channels" data={shippingChannels} />
              {/* <PlatformCard
                title="Notification Platform"
                data={NotificationPlatforms}
              /> */}
              <PlatformCard
                title="Others Platform"
                items={["Amazon", "FlipKart", "Shopify", "Noon"]}
              />
            </div>
          </div>
        </div>
      </div>
      <NewCommonModal
        title={"Edit Merchant"}
        open={credential}
        closeButtonText={"Cancel"}
        onClose={credentialToggleModal}
        actionButtonText={isPending ? "Updating..." : "Update"}
        actionButtonOnClick={handleSubmit(handleUpdate)}
        isPending={isPending}
      >
        <AddMerchantModal
          register={register}
          errors={errors}
          clearErrors={clearErrors}
          setValue={setValue}
          control={control}
          getIds={getIds}
          watch={watch}
          setSelectedDocument={setSelectedDocument}
          merchantData={merchantData}
        />
      </NewCommonModal>
    </>
  );
}
